const { String } = require('stdlib/String')

/**
 * Visszaadja a `min` és `max` közötti hónapokat.
 * @param {string} min - A minimum DateTime.
 * @param {string} max - A maximum DateTime.
 * @returns {ReadonlyArray<string>} A megadott DateTime-ok közötti hónapok.
 */
module.exports.getMonthsBetweenDates = function getMonthsBetweenDates (min, max) {
  /**
   * A `date` időpontból kiveszi az évet és a hónapot.
   * @param {Date} date - Az aktuális időpont.
   * @returns {string} A `date`-ből kivett adat.
   */
  function getData (date) { // eslint-disable-line unicorn/consistent-function-scoping -- TODO: refakt
    return `${ date.getFullYear() }-${ String.pad(date.getMonth() + 1) }`
  }

  const minDate = new Date(min)
  const maxDateData = getData(new Date(max))

  let addMonths = 1

    /**
     * @type {Array<string>}
     */
  const dates = [ getData(minDate) ]

  while (!dates.includes(maxDateData)) {
    const newDate = new Date(minDate)

    newDate.setMonth(newDate.getMonth() + addMonths)

    dates.push(getData(newDate))

    addMonths++
  }

  return dates
}
